'use client';

import { Star } from 'lucide-react';
import Button from '@/components/ui/Button';
import { plusCopy } from './plusCopy';
import { PlusPurchaseFlow } from './PlusPurchaseFlow';
import { cn } from '@/lib/utils/utils';

const BuyPlusButton = ({
  isEnglish = false,
  className,
}: {
  isEnglish?: boolean;
  className?: string;
}) => {
  const t = isEnglish ? plusCopy.en : plusCopy.mn;

  return (
    <PlusPurchaseFlow isEnglish={isEnglish}>
      {(open) => (
        <Button
          variant="secondary"
          className={cn('mt-4 h-10 shrink-0 rounded-lg px-5', className)}
          onClick={() => open()}
        >
          <Star className="h-4 w-4" />
          {t.activate}
        </Button>
      )}
    </PlusPurchaseFlow>
  );
};

export default BuyPlusButton;
